import { useState } from "react";
import { ColorBox } from "./ColorBox";

export function AddColor() {
  // const styles = { background - color: "green" };
  const [color, setColor] = useState("");
  const styles = { backgroundColor: color };
  // Tying -> onChange -> event.target.value (content) -> setColor
  // React will update the color in the view (screen) -> render -> re-render
  const [colors, setColors] = useState(["pink", "orange", "crimson"]);
  return (
    <div>
      <input
        style={styles}
        onChange={(event) => setColor(event.target.value)}
        placeholder="Enter a color"
      />
      {/* copy of colors & then add the new color to it*/}
      <button onClick={() => setColors([...colors, color])}>Add color</button>

      {colors.map((clr, index) => (
        <ColorBox key={index} clrA={clr} />
      ))}
    </div>
  );
}
